import { render, staticRenderFns } from "./addClient.vue?vue&type=template&id=23d35ca4"
import script from "./addClient.vue?vue&type=script&lang=js"
export * from "./addClient.vue?vue&type=script&lang=js"
import style0 from "./addClient.vue?vue&type=style&index=0&id=23d35ca4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports